<template>
  <div class="content-dashboard">
    <h3>Mes Contacts</h3>

    <div class="row mt-3 align-items-center">
      <template v-for="deleg in delegues" :key="deleg.id">
        <div class="col-lg-4 mb-4">
          <div class="box-contact">
            <p>Votre délégué vétérinaire :</p>
            <ul>
              <li v-if="deleg.lastName">
                <img :src="user" /><span>{{ deleg.lastName }}</span>
              </li>
              <li v-if="deleg.phoneNumber">
                <img :src="phone" /><span>{{ deleg.phoneNumber }}</span>
              </li>
              <li v-if="deleg.email">
                <img :src="envelope" /><span>{{ deleg.email }}</span>
              </li>
            </ul>
          </div>
        </div>
      </template>
      <template v-for="(service, index) in services" :key="index">
        <div class="col-lg-4 mb-4">
          <div class="box-contact">
            <p>{{ service.titre }} :</p>
            <ul>
              <li v-if="service.userName">
                <img :src="user" /><span>{{ service.userName }}</span>
              </li>
              <li v-if="service.telephone">
                <img :src="phone" /><span>{{ service.telephone }}</span>
              </li>
              <li v-if="service.email">
                <img :src="envelope" /><span>{{ service.email }}</span>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import phone from "@/assets/images/phone.svg";
  import user from "@/assets/images/user.svg";
  import envelope from "@/assets/images/envelope.svg";
  import { useContactsStore } from "@/stores/contactStore";

  export default {
    name: "MesContactsView",
    data() {
      return {
        phone,
        user,
        envelope,
        contactStore: null,
        veterinaire: {},
      };
    },
    computed: {
      services() {
        return useContactsStore()
          .Services.slice()
          .sort((a, b) => a.id - b.id);
      },
      delegues() {
        return useContactsStore()
          .Delegues.slice()
          .sort((a, b) => a.id - b.id);
      },
      loading() {
        return useContactsStore().loading;
      },
    },
    created() {
      this.contactStore = useContactsStore();
      this.contactStore.fetchServices_Delegues();
    },
  };
</script>
